import React from 'react'
import {
  Box,
  Typography,
  Grid,
  Chip,
  Card,
  CardContent,
  Stack,
  Divider,
  Link,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material"
import { getTitle } from '../../function/string'
import sprite_ from '../../sass/sprite.module.sass'
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { useAccordionStyles } from '../../style/lookup'

interface SndrCommonProps {
  sndrData: any
}

const Sndr: React.FC<SndrCommonProps> = ({ sndrData }) => {
  const accordionClasses: any = useAccordionStyles()
  const result = sndrData && Array.isArray(sndrData.data)
    && sndrData.data.length > 0
    && sndrData.data[0].filter((obj: any) => Object.keys(obj).length > 0 && obj.type !== "leaks")

  const [q, setQ] = React.useState('')
  const isUrl = (val: any) => typeof val === 'string' && /^(https?:\/\/|www\.)/i.test(val)
  const renderValue = (val: any) => {
    if (val === null || val === undefined) return <Typography >-</Typography>
    if (typeof val === 'number') return <Typography variant="body2" sx={{ letterSpacing: 0.4, ml: 0.75 }}>{val}</Typography>
    if (typeof val === 'string') {
      return isUrl(val) ? (
        <Link href={val} target="_blank" rel="noopener noreferrer" sx={{ letterSpacing: 0.4, ml: 0.75 }}>{val}</Link>
      ) : (
        <Typography variant="body2" sx={{ letterSpacing: 0.4, ml: 0.75 }}>{val}</Typography>
      )
    }
    try {
      return (
        <Typography variant="body2" sx={{ letterSpacing: 0.4, ml: 0.75 }}>{JSON.stringify(val, null, 2)}</Typography>
      )
    } catch {
      return <Typography variant="body2" color="text.secondary">[unrenderable]</Typography>
    }
  }

  const filterText = (obj: any) => {
    const hay = JSON.stringify(obj).toLowerCase()
    return hay.includes(q.toLowerCase())
  }

  const filtered: any[] = result && result?.length > 0 && result?.filter((it: any) => filterText(it))
  return (
    <Accordion
      classes={accordionClasses}
      square
      sx={{ width: '100%' }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ width: '100%' }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%' }}>
          <Box
            className={sprite_['social__small_' + sndrData?.from]}
          />
          <Typography
            variant="semiBold"
            sx={{ textTransform: 'capitalize' }}
          >
            {getTitle(sndrData.from)}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Divider
          sx={{
            margin: '-5px 0px 15px 0px',
            border: `0.1px solid rgba(46, 151, 213, 0.3)`,
          }}
        />
        <Box sx={{ maxWidth: 1200, mx: 'auto', p: 2 }}>
          <Stack
            direction="column"
            spacing={1.5}
            alignItems="flex-start"
            sx={{ mb: 2, pl: 2 }}
          >
            <Typography variant="h6" fontWeight={600}>
              {filtered?.length && filtered?.length > 0 ? 'SNDR — Results' : 'No results found'}
            </Typography>
          </Stack>
          <Grid container spacing={2}>
            {filtered && filtered.length > 0 && filtered.map((item: any, idx: number) => (
              item.type !== 'error' && (
              <Grid item xs={12} key={idx}>
                <Card variant="outlined" sx={{ height: '100%', display: 'flex' }}>
                  <CardContent>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ textTransform: 'uppercase', letterSpacing: 0.4, ml: 1.5 }}>
                        {item.type || 'ITEM'}
                      </Typography>
                      {typeof item.domain_valid === 'boolean' && (
                        <Chip size="small" label={item.domain_valid ? 'valid' : 'invalid'} color={item.domain_valid ? 'success' : 'error'} />
                      )}
                    </Stack>

                    <Grid container spacing={1}>
                      {Object.entries(item).map(([key, value]) => (
                        key === 'type' ? null : (
                          <Grid item xs={12} key={key}>
                            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.4, ml: 1.5 }}>{key}:</Typography>
                            <Typography variant="caption" sx={{ textTransform: 'uppercase', letterSpacing: 0.4, ml: 0.75 }}>{renderValue(value)}</Typography>
                          </Grid>
                        )
                      ))}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              )
            ))}
            {filtered.length === 0 && (
              <Grid item xs={12}>
                <Typography variant="body2" color="text.secondary">Not found</Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default Sndr